import React from 'react'

import { ZariContext } from '_zari/context'
import { Table, Button, Row, Col } from '_zari/core'

import { Select2CodigoEnlace } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import * as CuentaContableService from 'services/cuentaContable.service'

const CodigoEnlaceCell = ({ row }) => {
  const __zariContext = React.useContext(ZariContext)

  const [codigoEnlace, setCodigoEnlace] = React.useState(row.codigoEnlace || '')
  const [nombreEnlace, setNombreEnlace] = React.useState(row.nombreEnlace || '')

  const clickClear = React.useCallback(() => {
    setNombreEnlace('')
    setCodigoEnlace('')
  }, [])

  const onChangeSelect2 = React.useCallback(optionData => {
    setCodigoEnlace(optionData.value)
    setNombreEnlace(optionData.label)
  }, [])

  const clickGuardar = React.useCallback(() => {
    __zariContext.loader.open('Actualizando registro')
    CuentaContableService.actualizarCodigoEnlacexId(row._id, { codigoEnlace })
      .then(() => {
        __zariContext.snack('success', 'Registro actualizado')
      })
      .catch(() => {
        __zariContext.snack('error', 'No se pudo actualizar el registro')
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, row._id, codigoEnlace])

  return (
    <>
      <Table.Cell className='zari-slim-form'>
        <Row>
          {row.flagAnalitica ? (
            <>
              <Col md={8}>
                {nombreEnlace ? (
                  <>
                    <ClearInputGroup id={`${row._id}-clear`} iValue={nombreEnlace} clickClear={clickClear} />
                  </>
                ) : (
                  <>
                    <Select2CodigoEnlace id={`${row._id}-select2`} onChange={onChangeSelect2} />
                  </>
                )}
              </Col>
              <Col md={4}>
                <Button outline color='primary' tiny onClick={clickGuardar}>
                  Guardar
                </Button>
              </Col>
            </>
          ) : (
            <></>
          )}
        </Row>
      </Table.Cell>
    </>
  )
}

export default React.memo(CodigoEnlaceCell)
